import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traduções do português
import commonPt from './locales/pt/common.json';
import headerPt from './locales/pt/header.json';
import sidemenuPt from './locales/pt/sidemenu.json';
import dashboardPt from './locales/pt/dashboard.json';
import jobsPt from './locales/pt/jobs.json';
import processingsPt from './locales/pt/processings.json';
import loginPt from './locales/pt/login.json';
import editorPt from './locales/pt/editor.json';
import environmentsPt from './locales/pt/environments.json';
import knowledgeBasePt from './locales/pt/knowledgeBase.json';
import consumptionPt from './locales/pt/consumption.json';

// Importar traduções do inglês
import commonEn from './locales/en/common.json';
import headerEn from './locales/en/header.json';
import sidemenuEn from './locales/en/sidemenu.json';
import dashboardEn from './locales/en/dashboard.json';
import jobsEn from './locales/en/jobs.json';
import processingsEn from './locales/en/processings.json';
import loginEn from './locales/en/login.json';
import editorEn from './locales/en/editor.json';
import environmentsEn from './locales/en/environments.json';
import knowledgeBaseEn from './locales/en/knowledgeBase.json';
import consumptionEn from './locales/en/consumption.json';

// Importar traduções do espanhol
import commonEs from './locales/es/common.json';
import headerEs from './locales/es/header.json';
import sidemenuEs from './locales/es/sidemenu.json';
import dashboardEs from './locales/es/dashboard.json';
import jobsEs from './locales/es/jobs.json';
import processingsEs from './locales/es/processings.json';
import loginEs from './locales/es/login.json';
import editorEs from './locales/es/editor.json';
import environmentsEs from './locales/es/environments.json';
import knowledgeBaseEs from './locales/es/knowledgeBase.json';
import consumptionEs from './locales/es/consumption.json';

// Configuração dos recursos de tradução
const resources = {
  pt: {
    common: commonPt.common,
    header: headerPt.header,
    sidemenu: sidemenuPt.sidemenu,
    dashboard: dashboardPt.dashboard,
    jobs: jobsPt.jobs,
    processings: processingsPt.processings,
    login: loginPt.login,
    editor: editorPt.editor,
    environments: environmentsPt.environments,
    knowledgeBase: knowledgeBasePt.knowledgeBase,
    consumption: consumptionPt.consumption,
    languages: commonPt.languages,
  },
  en: {
    common: commonEn.common,
    header: headerEn.header,
    sidemenu: sidemenuEn.sidemenu,
    dashboard: dashboardEn.dashboard,
    jobs: jobsEn.jobs,
    processings: processingsEn.processings,
    login: loginEn.login,
    editor: editorEn.editor,
    environments: environmentsEn.environments,
    knowledgeBase: knowledgeBaseEn.knowledgeBase,
    consumption: consumptionEn.consumption,
    languages: commonEn.languages,
  },
  es: {
    common: commonEs.common,
    header: headerEs.header,
    sidemenu: sidemenuEs.sidemenu,
    dashboard: dashboardEs.dashboard,
    jobs: jobsEs.jobs,
    processings: processingsEs.processings,
    login: loginEs.login,
    editor: editorEs.editor,
    environments: environmentsEs.environments,
    knowledgeBase: knowledgeBaseEs.knowledgeBase,
    consumption: consumptionEs.consumption,
    languages: commonEs.languages,
  },
};

// Configuração personalizada do detector de idioma
const detectionOptions = {
  // Ordem de detecção: localStorage -> navegador -> fallback
  order: ['localStorage', 'navigator', 'htmlTag'],
  
  // Cache do idioma selecionado no localStorage
  caches: ['localStorage'],
  
  // Chave para salvar no localStorage
  lookupLocalStorage: 'i18nextLng',
  
  // Não converter o código do idioma
  convertDetectedLanguage: (lng) => {
    // Mapear códigos de idioma para os nossos suportados
    if (lng.startsWith('pt')) return 'pt';
    if (lng.startsWith('en')) return 'en';
    if (lng.startsWith('es')) return 'es';
    return 'pt'; // fallback para português
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    
    // Idioma padrão
    fallbackLng: 'pt',
    
    // Namespace padrão
    defaultNS: 'common',
    
    // Configuração do detector
    detection: detectionOptions,
    
    // Habilitar contexto e pluralização
    interpolation: {
      escapeValue: false, // React já faz escape
    },
    
    // Configurações adicionais
    react: {
      useSuspense: false, // Evitar problemas com Suspense
    },
    
    // Debug apenas em desenvolvimento
    debug: process.env.NODE_ENV === 'development',
    
    // Separador para namespaces
    nsSeparator: ':',
    
    // Separador para chaves aninhadas
    keySeparator: '.',
  });

export default i18n; 